export default __webpack_public_path__ + "static/media/newsletter.f595b04d.webp";